module.exports = __webpack_public_path__ + "img/4-1.dcfbe2b5.svg";